import { customerGroupSchema } from "@redotech/redo-model/customers/customer-group-definition";
import * as z from "zod/v4";

export const fetchSegmentById = {
  name: "fetchSegmentById" as const,
  input: z.string(),
  output: customerGroupSchema,
};
